import React from 'react'

import Safra from 'entity/Safra'

import DefaultEntityCrud from 'components/form/DefaultEntityCrud'
import FormContent from 'components/form/FormContent'
import TextInput from 'components/form/input/TextInput'
import SelectInput from 'components/form/input/SelectInput'


function SafraFormInter(props) {
    return (
        <FormContent sx={{ p: 2 }}>

            <TextInput sx={{ flex: 0.5 }} name="sequencialIndex" label="Código" disabled />

            <SelectInput
                sx={{ flex: 0.5 }}
                name="status"
                label="Status"
                options={["ATIVO", "INATIVO"]}
                required
            />
            <TextInput sx={{ flex: 2 }} name="safra" label="Safra" required />
        </FormContent>
    )
}

export default function SafraForm() {
    return (
        <DefaultEntityCrud
            title={"Cadastro de Safra"}
            EntityClass={Safra}
            routeForm={"_safra"}
            backRoute="consulta-safra"

            formActions={{ novoForm: false, salvarForm: true, sairForm: true }}
        >
            {(props) => <SafraFormInter {...props} />}
        </DefaultEntityCrud>
    )
}
